import KshitizImage from '../../LandingV0/assets/images/kshitiz-v2.png'

export const DSAVideoSectionData = {
  image: KshitizImage.src,
  name: 'Kshitiz Miglani',
  firstPosition: 'co-founder @Devsnest',
  secondPosition: 'Ex- Samsung'
}

export const FrontendVideoSectionData = {
  image: KshitizImage.src,
  name: 'Gaurav Sen',
  firstPosition: 'Mentor with exp of 10 years',
  secondPosition: ''
}

export const BackendVideoSectionData = {
  image: KshitizImage.src,
  name: 'Kshitiz Miglani',
  firstPosition: 'co-founder @Devsnest',
  secondPosition: 'Ex- Samsung'
}

export const FullStackVideoSectionData = {
  image: KshitizImage.src,
  name: 'Kshitiz Miglani',
  firstPosition: 'co-founder @Devsnest',
  secondPosition: 'Ex- Samsung'
}

export const VideoSectionData = {
  dsa: DSAVideoSectionData,
  frontend: FrontendVideoSectionData,
  backend: BackendVideoSectionData,
  fullstack: FullStackVideoSectionData
} as const
